export function getOkayClass(field) {
    return field === null || field === "" ? "" : "okay";
}